/* eslint-disable */
import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

//Custom components
import DialogToolbarMenuItem from "@/ui/Dialog/DialogToolbarMenuItem";

//Types
import { IDialogToolbarMenuItemDetail } from "@/@types/ui/Dialog";

const DialogToolbarMenuItemActivate = React.forwardRef<HTMLLIElement, IDialogToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();

  return <DialogToolbarMenuItem label={t("buttons.activate")} icon={<CheckCircleIcon />} {...props} ref={ref} />;
});

export default DialogToolbarMenuItemActivate;
